import { render, staticRenderFns } from "./ResDetailCard.vue?vue&type=template&id=1eb94c36&scoped=true&lang=pug"
import script from "./ResDetailCard.vue?vue&type=script&lang=js"
export * from "./ResDetailCard.vue?vue&type=script&lang=js"
import style0 from "./ResDetailCard.vue?vue&type=style&index=0&id=1eb94c36&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eb94c36",
  null
  
)

export default component.exports